const galleryId = -1;

const items = [];

let id = galleryId * 1000;
function addItemToGroup(item, tag) {
    id++;
    items.push({
        "id": id,
        "title": { "en": "" },
        "src": item,
        "tags": [tag],
        "groups": [galleryId],
        "ordering": id,
    });
}

const groupUnknown = [
"shutterstock_1645118599.jpg",
"shutterstock_1645118596.jpg",
"shutterstock_1361950133.jpg",
"shutterstock_1248434191.jpg",
"shutterstock_1647109045.jpg",
"shutterstock_1382843888.jpg",
"shutterstock_1505970371.jpg",
"shutterstock_1536186932.jpg",
"shutterstock_1165128304.jpg",
"shutterstock_1843168030.jpg",
"shutterstock_85691473.jpg",
"shutterstock_85691464.jpg",
"shutterstock_1434062699.jpg",
"shutterstock_1710517909.jpg",
"shutterstock_1646434084.jpg",
"shutterstock_1512081779.jpg",
"shutterstock_1713449380.jpg",
"shutterstock_1713798562.jpg",
"shutterstock_1691417698.jpg",
"shutterstock_1516469219.jpg",
"shutterstock_1720712938.jpg",
"shutterstock_1047275122.jpg",
"shutterstock_1710517906.jpg",
"shutterstock_1505786330.jpg",
"shutterstock_1741122335.jpg",
"shutterstock_1829640728.jpg",
"shutterstock_1710517921.jpg",
"shutterstock_1396865246.jpg",
"shutterstock_1710517900.jpg",
"shutterstock_1680226489.jpg",
"shutterstock_1683481240.jpg",
"shutterstock_1710517927.jpg",
"shutterstock_1710517903.jpg",
"shutterstock_1048216483.jpg",
"shutterstock_1515099938.jpg",
"shutterstock_1645168276.jpg",
"shutterstock_1741122272.jpg",
"shutterstock_1565398816.jpg",
"shutterstock_795144658.jpg",
"shutterstock_1396865237.jpg",
"shutterstock_767551351.jpg",
"shutterstock_1443382517.jpg",
"shutterstock_1562633719.jpg",
"shutterstock_1256946910.jpg",
"shutterstock_537170143.jpg",
"shutterstock_1522470902.jpg",
"shutterstock_1082449385.jpg",
"shutterstock_1758922706.jpg",
"shutterstock_225206851.jpg",
"shutterstock_694710046.jpg",
"shutterstock_577643599.jpg",
"shutterstock_577643587.jpg",
"shutterstock_1158501490.jpg",
"shutterstock_1008462970.jpg",
"shutterstock_1822690388.jpg",
"shutterstock_1734010490.jpg",
"shutterstock_1710200311.jpg",
"shutterstock_1274845465.jpg",
"shutterstock_1254136210.jpg",
"shutterstock_1486979432.jpg",
"shutterstock_1808525872.jpg",
"shutterstock_1582204078.jpg",
"shutterstock_1702192570.jpg",
"shutterstock_1479855842.jpg",
"shutterstock_1211429056.jpg",
"shutterstock_1444882397.jpg",
"shutterstock_690358765.jpg",
"shutterstock_1015348405.jpg",
"shutterstock_1307277547.jpg",
"shutterstock_1301948821.jpg",
"shutterstock_1108315907.jpg",
"shutterstock_1646434027.jpg",
"shutterstock_1678807423.jpg",
"shutterstock_1309934572.jpg",
"shutterstock_100322954.jpg",
"shutterstock_351429728.jpg",
"shutterstock_1852850374.jpg",
"shutterstock_1729800100.jpg",
"shutterstock_4416745.jpg",
"shutterstock_1662934903.jpg",
"shutterstock_1512852149.jpg",
"shutterstock_1797489919.jpg",
"shutterstock_227755375.jpg",
// "shutterstock_1425857237.jpg", // TODO: 403
// "shutterstock_1641228880.jpg", // TODO: 403
// "shutterstock_1665353194.jpg", // TODO: 403
// "shutterstock_250863919.jpg", // TODO: 403
// "shutterstock_367397651.jpg", // TODO: 403
// "shutterstock_414878863.jpg", // TODO: 403
// "shutterstock_726685072.jpg", // TODO: 403
// "shutterstock_124420102.jpg", // TODO: 403
// "shutterstock_124420087.jpg", // TODO: 403
// "shutterstock_124420078.jpg", // TODO: 403
"shutterstock_1737653789.jpg",
"shutterstock_1732973102.jpg",
"shutterstock_1732613363.jpg",
// "shutterstock_1244391772.jpg", // TODO: 403
// "shutterstock_417791032.jpg",// TODO: 403
"shutterstock_1708644454.jpg",
"shutterstock_1764105380.jpg",
"shutterstock_204887047.jpg",
// "shutterstock_1110234464.jpg", // TODO: 403
// "shutterstock_1751269484.jpg", // TODO: 403
// "shutterstock_1730146399.jpg", // TODO: 403
// "shutterstock_1435953932.jpg", // TODO: 403
// "shutterstock_1743878648.jpg", // TODO: 403
// "shutterstock_1240381027.jpg", // TODO: 403
// "shutterstock_511088296.jpg", // TODO: 403
// "shutterstock_524037013.jpg", // TODO: 403
// "shutterstock_504131500.jpg", // TODO: 403
// "shutterstock_504131488.jpg", // TODO: 403
// "shutterstock_504131494.jpg", // TODO: 403
// "shutterstock_532324357.jpg", // TODO: 403
// "shutterstock_507017881.jpg", // TODO: 403
// "shutterstock_548231284.jpg", // TODO: 403
// "shutterstock_507017890.jpg", // TODO: 403
// "shutterstock_1234819225.jpg", // TODO: 403
// "shutterstock_627379304.jpg", // TODO: 403
// "shutterstock_560464690.jpg", // TODO: 403
// "shutterstock_1493475077.jpg", // TODO: 403
// "shutterstock_660386209.jpg", // TODO: 403
// "shutterstock_655853674.jpg", // TODO: 403
// "shutterstock_716728030.jpg", // TODO: 403
];

groupUnknown.forEach((i) => addItemToGroup(i, 'x'));

export default items;
